import { logger } from "cayo.ui";
import { IActionHandlerParams } from "../types";

const log = logger.getLogger("action-handlers");

export function previewQuery(_: string, parameters?: IActionHandlerParams) {
  if (!parameters?.dispatch || parameters.objects?.length !== 1) {
    return;
  }
  log.debug("previewQuery -> parameters", parameters);
  return parameters?.dispatch({
    kind: "escalate",
    action: { kind: "selectQuery", previewQuery: true, queryId: parameters?.objects[0]?.id },
  });
}
